import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import { EvaluatedLayout } from '@/components/layout/EvaluatedLayout';
import EvaluatedHome from '@/pages/enduser/EvaluatedHome';
import EvaluatedThankYou from '@/pages/enduser/EvaluatedThankYou';
import EndUserAssessment from '@/pages/enduser/EndUserAssessment';
import EndUserConsent from '@/pages/enduser/EndUserConsent';
import EndUserProfile from '@/pages/enduser/EndUserProfile';
import MeWorkforceRecords from '@/pages/enduser/MeWorkforceRecords';
import MePerformance from '@/pages/enduser/MePerformance';
import MeEvaluations from '@/pages/enduser/MeEvaluations';
import MeCompany from '@/pages/enduser/MeCompany';

/**
 * Iter 41 — Bare full-screen flow for Role 4 (Evaluated User).
 *
 *   /me/consent             → Informed Consent gate (always reachable)
 *   /me                     → Evaluation list (after consent)
 *   /me/assignments/:id     → Take the evaluation
 *   /me/assignments/:id/done→ Submission confirmation
 *
 * EvaluatedLayout enforces the hard consent gate: every route except
 * /me/consent redirects to /me/consent until the user has accepted.
 *
 * No sidebar. No portal navigation. Just logo + LanguageSwitcher + logout
 * in the top bar.
 */
export default function EndUserRoutes() {
  // Touch useTranslation so i18n suspense triggers as needed.
  useTranslation();
  return (
    <Routes>
      <Route element={<EvaluatedLayout />}>
        <Route path="consent"               element={<EndUserConsent />} />
        <Route path="profile"               element={<EndUserProfile />} />
        <Route path="workforce-records"     element={<MeWorkforceRecords />} />
        <Route path="performance"           element={<MePerformance />} />
        <Route path="evaluations"           element={<MeEvaluations />} />
        <Route path="company"               element={<MeCompany />} />
        <Route index                        element={<EvaluatedHome />} />
        <Route path="assignments/:id"       element={<EndUserAssessment />} />
        <Route path="assignments/:id/done"  element={<EvaluatedThankYou />} />
        <Route path="*"                     element={<Navigate to="/me" replace />} />
      </Route>
    </Routes>
  );
}
